<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
      span.validation-label(v-if="required == true") 必須

    .register-value
      .d-flex.justify-content-center
        input.register-form.datetime.mr-1(v-model="_value" :name="name" type="text" :placeholder="placeholder"
          v-validate="validationRules" :data-vv-as="(validationKeyName) ? validationKeyName : keyName" 
          :class="{ noinput: (required == true && !_value) }" @click="showModal" readonly)
        b-button.clear-btn(@click="ondelete")
          span クリア

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br

  EventDatetimePickerModal(v-model="show" :date.sync="_date" :startTime.sync="_startTime" :endTime.sync="_endTime" @ok="inputDatetime")
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import EventDatetimePickerModal from "@/pc/components/modals/EventDatetimePickerModal.vue";

/**
 * カレンダー入力コンポーネント
 *
 * - カレンダーでの日付入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component({
  components: {
    EventDatetimePickerModal
  }
})
export default class FormEventDatetimePicker extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: number;
  /** 日付 */
  @Prop({ required: true })
  date!: string;
  /** 開始時刻 */
  @Prop({ required: true })
  startTime!: string;
  /** 終了時刻 */
  @Prop({ required: true })
  endTime!: string;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** input要素のプレースホルダー */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  placeholder!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  styles!: any;

  show: boolean = false;

  public showModal(): void {
    this.show = true;
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    if (this.value) {
      const date: string = this.$dateUtil.convertNumberToString(this.value, "yyyy年mm月dd日");
      const startTime: string = this.startTime.slice(0, 5);
      const endTime: string = this.endTime.slice(0, 5);

      return `${date} ${startTime} ～ ${endTime}`;
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    return;
  }

  public inputDatetime(): void {
    const date: string = this.$dateUtil.replaceNonNumeric(this.date); // date format is yyyy-mm-dd
    this.$emit("input", Number(`${date}000000000`));

    return;
  }

  get _date(): string {
    return this.date;
  }

  set _date(newValue: string) {
    this.$emit("update:date", newValue);
    return;
  }

  get _startTime(): string {
    return this.startTime;
  }

  set _startTime(newValue: string) {
    this.$emit("update:startTime", newValue);
    return;
  }

  get _endTime(): string {
    return this.endTime;
  }

  set _endTime(newValue: string) {
    this.$emit("update:endTime", newValue);
    return;
  }

  public ondelete(): void {
    this.$emit("input", null);
    return;
  }
}
</script>

<style lang="scss" scoped>
.register-form {
  min-width: 290px !important;
  width: 290px !important;
}
</style>
